import type { ModalSizeType } from "@circle-react-uikit/ModalV2/ModalContent";

export interface CompassModalProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export type UIKitVariant = "primary" | "danger" | "circle";
export type CompassVariant = "primary" | "destructive";
export type CompassSize = "sm" | "md" | "lg" | "full-width";

export const toCompassVariant = (variant?: UIKitVariant): CompassVariant => {
  switch (variant) {
    case "danger":
      return "destructive";
    case "primary":
    case "circle":
    default:
      return "primary";
  }
};

export const toCompassSize = (size?: ModalSizeType): CompassSize => {
  switch (size) {
    case "sm":
      return "sm";
    case "md":
      return "md";
    case "lg":
    case "xl":
    case "2xl":
      return "lg";
    case "full":
      return "full-width";
    default:
      return "md";
  }
};
